import {
  ListItemSecondaryAction as MuiListItemSecondaryAction,
  ListItemSecondaryActionProps,
} from '@mui/material';

/**
 * @deprecated Use ListItemProps.secondaryActions instead.
 */
// eslint-disable-next-line deprecation/deprecation
export const ListItemSecondaryAction = MuiListItemSecondaryAction;

// eslint-disable-next-line deprecation/deprecation
export default ListItemSecondaryAction;

export type { ListItemSecondaryActionProps };
